// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"552b284c","159":"c9321d8c","256":"972d7045","388":"315d448e","407":"c9c9195f","484":"a99e5a98","517":"27e5a1dc","638":"5b757390","691":"a36d68d2","705":"f423181a","759":"abba1304","832":"b72b0003","846":"72c838ea","860":"e36de874","968":"a0dcb4d0"}[chunkId] + ".chunk.js";
};